export const documentCategories = [
  {
    title: "Identification Docs",
    docs: ["PAN Card", "Aadhar Card", "Passport"],
    storageKeyMap: {
      "PAN Card": "pan",
      "Aadhar Card": "aadhar",
      Passport: "passport",
    },
  },
  {
    title: "Academic Docs",
    docs: ["10th Marksheet", "12th Marksheet", "UG Transcript"],
    storageKeyMap: {
      "10th Marksheet": "10th_marksheet",
      "12th Marksheet": "12th_marksheet",
      "UG Transcript": "ug_transcript",
    },
  },
  {
    title: "Financial Docs",
    docs: [
      "Last 3 month salary slip",
      "Last 6 month bank statement",
      "IT Returns for past 2 years",
    ],
    storageKeyMap: {
      "Last 3 month salary slip": "3_month_salary_slip",
      "Last 6 month bank statement": "6_month_bank_statement",
      "IT Returns for past 2 years": "it_returns",
    },
  },
  {
    title: "Parents Docs",
    docs: [
      "Father's PAN Card",
      "Father's Aadhar Card",
      "Mother's PAN Card",
      "Mother's Aadhar Card",
    ],
    storageKeyMap: {
      "Father's PAN Card": "father_pan",
      "Father's Aadhar Card": "father_aadhar",
      "Mother's PAN Card": "mother_pan",
      "Mother's Aadhar Card": "mother_aadhar",
    },
  },
  {
    title: "Co-applicant Docs",
    docs: [
      "Co-applicant PAN",
      "Co-applicant Aadhar",
      "Co-applicant Electricity Bill",
      "Co-applicant Last 3 month salary slip",
      "Co-applicant Last 6 month bank statement",
      "Co-applicant IT Returns for past 2 years",
      "Co-applicant Scanned cheque copy",
    ],
    storageKeyMap: {
      "Co-applicant PAN": "co_applicant_pan",
      "Co-applicant Aadhar": "co_applicant_aadhar",
      "Co-applicant Electricity Bill": "co_applicant_electricity_bill",
      "Co-applicant Last 3 month salary slip": "co_applicant_3_month_salary_slip",
      "Co-applicant Last 6 month bank statement": "co_applicant_6_month_bank_statement",
      "Co-applicant IT Returns for past 2 years": "co_applicant_it_returns",
      "Co-applicant Scanned cheque copy": "co_applicant_scanned_cheque",
    },
  },
];

export const docKeyNames = documentCategories.reduce((acc, category) => {
  category.docs.forEach((doc) => {
    acc[doc] = category.storageKeyMap[doc];
  });
  return acc;
}, {});

export const loanApplicationStages = {
  PENDING: "PENDING",
  INITIATED: "INITIATED",
  DOCUMENT_UPLOADED: "DOCUMENT_UPLOADED",
  CONTACT_DETAILS_PROVIDED: "CONTACT_DETAILS_PROVIDED",
};
